import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import React from 'react'
import UserSettingTab from 'components/common/UserSettingTab/UserSettingTab'
import { useStyles } from './styles'

const PaymentMethod = ({ image, number, type, removeAction }) => {
    const classes = useStyles()
    return (
        <div className={classes.paymentMethod}>
            <div className={classes.info}>
                <img src={image} className={classes.image} alt={type} />
                <div>
                    <div className={classes.number}>{`Ending in ${number}`}</div>
                    <div className={classes.type}>{type}</div>
                </div>
            </div>
            <CallToActionButton
                onClick={removeAction}
                className={classes.removeButton}
                type="default"
                text={'Remove'}
            />
        </div>
    )
}

const Payment = ({ paymentMethods, removePaymentMethod }) => {
    const classes = useStyles()
    return (
        <UserSettingTab title="Payment Information">
            {(!paymentMethods || paymentMethods.length === 0) && (
                <span className={classes.type}>You currently have no saved payment methods.</span>
            )}
            {Array.isArray(paymentMethods) &&
                paymentMethods.map((pm, i) => (
                    <PaymentMethod
                        key={i}
                        image={pm.imageUrl}
                        number={pm.maskedNumber.substr(12, 16)}
                        type={pm.cardType}
                        removeAction={() => removePaymentMethod(pm)}
                    />
                ))}
        </UserSettingTab>
    )
}

export default React.memo(Payment)
